var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { throttle } from "lodash-es";
import { useCallback, useRef, useState } from "react";
import { globalEvents } from "../../common/GlobalEvents";
import { useIsMounted } from "../../common/hooks/useIsMounted";
import { LoaderEvent } from "../loader/constants";
import { useJWTHeader } from "./useJWTHeader";
export var useAxiosPost = function (url, payload, config, showLoader) {
    if (showLoader === void 0) { showLoader = true; }
    var isMounted = useIsMounted();
    var _a = useState(null), response = _a[0], setResponse = _a[1];
    var _b = useState(null), postError = _b[0], setPostError = _b[1];
    var _c = useState(false), isPosting = _c[0], setIsPosting = _c[1];
    var _d = useState(-1), axiosStatus = _d[0], setAxiosStatus = _d[1];
    var postUrl = useRef("");
    var throttledSetIsPosting = useRef(throttle(function (val) { return isMounted() && setIsPosting(val); }, 300));
    var newConfig = useJWTHeader(config);
    var postData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var controller, _a, data, status, config_1, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    postUrl.current = "";
                    setResponse(null);
                    setPostError(null);
                    if (!url)
                        return [2 /*return*/];
                    controller = new AbortController();
                    if (showLoader) {
                        globalEvents.emit(LoaderEvent.SHOW_SPLASH);
                    }
                    throttledSetIsPosting.current(true);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axios.post(url, payload, newConfig)];
                case 2:
                    _a = _e.sent(), data = _a.data, status = _a.status, config_1 = _a.config;
                    postUrl.current = (_b = config_1 === null || config_1 === void 0 ? void 0 : config_1.url) !== null && _b !== void 0 ? _b : "";
                    setAxiosStatus(status);
                    setResponse(data);
                    if (showLoader)
                        globalEvents.emit(LoaderEvent.HIDE_SPLASH);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _e.sent();
                    postUrl.current = (_d = (_c = error_1.config) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : "";
                    setResponse(null);
                    setPostError(error_1);
                    if (showLoader)
                        globalEvents.emit(LoaderEvent.HIDE_SPLASH);
                    return [3 /*break*/, 5];
                case 4:
                    throttledSetIsPosting.current(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, function () { return controller.abort(); }];
            }
        });
    }); }, [url, payload, newConfig, showLoader]);
    return {
        postUrl: postUrl.current,
        postData: postData,
        isPosting: isPosting,
        response: response,
        postError: postError,
        axiosStatus: axiosStatus,
    };
};
